export default () => {
    var cssFont = document.createElement('link');
    cssFont.href = "https://fonts.googleapis.com/css?family=Noto+Sans+TC:100,300,400,500,700,900&display=swap"
    cssFont.rel = "stylesheet"
    document.getElementsByTagName('head')[0].appendChild(cssFont)
};